import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { AiOutlineLeft, AiOutlineCheckCircle } from "react-icons/ai";
import { PrimaryButton } from "../../reusble_components/buttons/primaryButton";
import { useNavigate } from "react-router-dom";
import PdfViewer from "../../reusble_components/pdfViewer";
import MediaPopup from "../../reusble_components/popup/MediaPopup";

export default function TaskPreview({ isEdit }) {
  const { CommonStore, RecuiterStore, PopupStore } = useStores();
  const navigate = useNavigate();

  const handleBack = () => {
    CommonStore.setProgress(CommonStore.progress - 1);
  };

  const handleNext = () => {
    CommonStore.setProgress(CommonStore.progress + 1);
  };

  const taskDetails = RecuiterStore.jobPostDetails.taskDetails;
  console.log(taskDetails, "taskDetails");

  return useObserver(() => (
    <div className="w-full ">
      {PopupStore.pdfview && (
        <PdfViewer
          pdfUrl={PopupStore.mediaUrl}
          onClose={() => PopupStore.setPdfView(false)}
        />
      )}
      <MediaPopup />
      {!RecuiterStore.jobPostDetails?.taskDetails?.skipped &&
        RecuiterStore.jobPostDetails?.taskDetails !== null &&
        RecuiterStore.jobPostDetails?.taskDetails !== undefined && (
          <div className="md:mx-8 mx-4 ">
            <div className="flex items-center space-x-2 mb-4">
              <AiOutlineCheckCircle className="text-green-500 text-3xl" />
              <span className="text-green-500 font-bold text-lg">
                Task Details
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 text-gray-800 mb-4">
              {taskDetails.title && (
                <div className="flex items-center">
                  <span className="pl-2">
                    Title:{" "}
                    <span className="font-bold">{taskDetails?.title}</span>
                  </span>
                </div>
              )}

              {taskDetails?.assessmentType && (
                <div className="flex items-center">
                  <span className="pl-2">
                    Type:{" "}
                    <span className="font-bold">
                      {taskDetails?.assessmentType}
                    </span>
                  </span>
                </div>
              )}

              {taskDetails.duration ? (
                <div className="flex items-center">
                  <span className="pl-2">
                    Duration:{" "}
                    <span className="font-bold">
                      {taskDetails?.duration} {taskDetails?.assessmentType === "coding" ? "minutes" : "days"}
                    </span>
                  </span>
                </div>
              ) : (
                <></>
              )}

              {taskDetails.levelOfAssessment && (
                <div className="flex items-center">
                  <span className="pl-2">
                    Level:{" "}
                    <span className="font-bold">
                      {taskDetails?.levelOfAssessment}
                    </span>
                  </span>
                </div>
              )}

              {taskDetails.levelOfInterview && (
                <div className="flex items-center">
                  <span className="pl-2">
                    Level:{" "}
                    <span className="font-bold">
                      {taskDetails?.levelOfInterview}
                    </span>
                  </span>
                </div>
              )}

              {taskDetails.noOfQuestions && (
                <div className="flex items-center">
                  <span className="pl-2">
                    No of Questions:{" "}
                    <span className="font-bold">{taskDetails?.noOfQuestions}</span>
                  </span>
                </div>
              )}

              {/* {taskDetails.language && (
                <div className="flex items-center">
                  <span className="pl-2">
                    Language:{" "}
                    <span className="font-bold">{taskDetails?.language}</span>
                  </span>
                </div>
              )} */}

              {taskDetails.cutOff && (
                <div className="flex items-center">
                  <span className="pl-2">
                    Cut Off:{" "}
                    <span className="font-bold">{taskDetails?.cutOff}</span>
                    {taskDetails?.assessmentType === "coding" ? "%" : ""}
                  </span>
                </div>
              )}

              {taskDetails.githubLink && (
                <div className="flex items-center">
                  <span className="pl-2">
                    GitHub Link:{" "}
                    <span className="font-bold">{taskDetails?.githubLink}</span>
                  </span>
                </div>
              )}

              {taskDetails.description && (
                <div className="col-span-1  md:col-span-3 lg:col-span-3">
                  <h4 className="pl-2 mb-2">Description:</h4>
                  {/<[a-z][\s\S]*>/i.test(taskDetails.description) ? (
                      <div
                        className="font-medium mt-1"
                        dangerouslySetInnerHTML={{ __html: taskDetails.description }}
                      />
                    ) : (
                      <p className="font-bold pl-2">{taskDetails.description}</p>
                    )}
                </div>
              )}

              {taskDetails.technologyUsed &&
                taskDetails.technologyUsed.length > 0 && (
                  <div className="pl-2 col-span-1 md:col-span-3 lg:col-span-3">
                    <h4 className="mb-2">Technologies/Tools:</h4>
                    <div className="flex flex-wrap gap-2 ">
                      {taskDetails?.technologyUsed?.map((tech, index) => (
                        <span
                          key={index}
                          className="bg-gray-100 px-3 py-1 rounded-full text-sm font-bold"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

              {taskDetails?.media && taskDetails?.media?.length > 0 && (
                <div className="pl-2 col-span-1 md:col-span-3 lg:col-span-3">
                  <h4 className="mb-2">Media Files:</h4>
                  <div className="flex flex-wrap gap-2 ">
                    {taskDetails?.media?.map((file, index) => (
                      <div
                        key={index}
                        className="border border-gray-300 cursor-pointer rounded-lg p-2 flex items-center gap-2"
                        onClick={() => {
                          if (file.type === "document") {
                            PopupStore.setPdfView(true);
                            PopupStore.setMediaUrl(file.url);
                          } else {
                            PopupStore.setMediaPopup(true);
                            PopupStore.setMediaType(file.type);
                            PopupStore.setMediaUrl(file.url);
                          }
                        }}
                      >
                        <span className="font-bold truncate max-w-[200px]">
                          {file.url.split("/").pop().substring(17)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
    </div>
  ));
}
